<script setup>
</script>
<template>
  <div class="page-container holiday-page share-market-holiday">
    <div class="holiday-banner-section">
      <!-- banner-start -->
      <section class="holiday-banner container_fld">
        <section class="breadcrumbs-sec">
          <div class="container breadcrumbs-ol block">
            <div class="stocks-indices-breadcrumbs_wrap">
              <ol class="stocks-indices-breadcrumbs">

                <li>
                  <a href="/">
                    <span>Home </span>
                  </a>
                </li>
                <!-- <li>
                  <a href="/invest-in-share-market/">
                    <span>Invest </span>
                  </a>
                </li> -->
                <li>
                  <span>BSE Holidays 2025 </span>
                </li>
              </ol>
            </div>
          </div>
        </section>

        <div class="container coantainer_sec block">
          <div class="row">
            <div class="col-md-7 col-sm-7 pddg_col">
              <div class="banner_txt">
                <div data-aos="fade-zoom-in" data-aos-easing="ease-in-back" data-aos-duration="2000"
                  data-aos-offset="0">
                  <div class="banner-text">
                    <h1 class="header"> BSE Holidays 2025</h1>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-5 pddg_col col-sm-5 desktop-content">

            </div>
          </div>
        </div>
      </section>
      <!-- banner-End -->
    </div>

    <section class="main-share-market-section">
      <div class="share-market-inner-section">
        <div class="main-heading">
          <p>The BSE holiday calendar contains the list of all national and festive days throughout the year when
            trading is paused. The BSE trading holidays include all national days and festive holidays.<br>
            The BSE trading holiday calendar 2025 includes holidays such as Diwali, Republic Day and Eid, among others.
            The first holiday of the year will be on account of Republic Day on January 26.<br>
            On all these holidays, the BSE will remain closed, with no trading in equity and equity derivatives
            segments.<br>
            The BSE’s regular trading hours are from 9:15 am to 3:30 pm on weekdays. Trading remains closed on all
            Saturdays and Sundays.
          </p>
        </div>
        <div class="holidays-tabs" id="sticky-tab">
          <a href="/stocks-market/share-market-holidays/" class="tabs-items bg-transparent rounded-none">Trading Holidays</a>
          <a href="/stocks-market/nse-holidays/" class="tabs-items bg-transparent rounded-none">NSE Holidays</a>
          <a href="/stocks-market/bse-holidays/" class="tabs-items bg-transparent rounded-none active">BSE Holidays</a>
          <a href="/stocks-market/mcx-holidays/" class="tabs-items bg-transparent rounded-none">MCX Holidays</a>
        </div>


        <section class="holidays">
          <div class="container home-container block">
            <div class="a-article-wrapper holidays-wrapper">
              <h2><strong>BSE Holidays falling on weekdays and weekends in 2025</strong></h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Stock Market Holiday List</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Eid-ul-Fitr (Ramzan Eid)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 1, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Bakri Eid</td>
                      <td>June 7, 2025</td>
                      <td>Saturday</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 2, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 5, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <a href="https://www.bseindia.com/static/markets/marketinfo/listholi.aspx#!#24CD">BSE 2025 Trading
                  Holiday Circular</a>
              </p>
              <h2>
                <strong>BSE holidays falling on weekdays in 2025 (14 holidays on weekdays)</strong>
              </h2>
              <div class="table-responsive">
                <table border="1">
                  <thead>
                    <tr>
                      <th>BSE Holiday List</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Maha Shivratri</td>
                      <td>February 26, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Holi</td>
                      <td>March 14, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Eid-ul-Fitr (Ramzan ID)</td>
                      <td>March 31, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Mahavir Jayanti</td>
                      <td>April 10, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Dr. Baba Saheb Ambedkar Jayanti</td>
                      <td>April 14, 2025</td>
                      <td>Monday</td>
                    </tr>
                    <tr>
                      <td>Good Friday</td>
                      <td>April 18, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Maharashtra Day</td>
                      <td>May 1, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Independence Day</td>
                      <td>August 15, 2025</td>
                      <td>Friday</td>
                    </tr>
                    <tr>
                      <td>Ganesh Chaturthi</td>
                      <td>August 27, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Dussehra/Gandhi Jayanti</td>
                      <td>October 2, 2025</td>
                      <td>Thursday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Laxmi Pujan</td>
                      <td>October 21, 2025</td>
                      <td>Tuesday</td>
                    </tr>
                    <tr>
                      <td>Diwali-Balipratipada</td>
                      <td>October 22, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Guru Nanak Jayanti</td>
                      <td>November 5, 2025</td>
                      <td>Wednesday</td>
                    </tr>
                    <tr>
                      <td>Christmas</td>
                      <td>December 25, 2025</td>
                      <td>Thursday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2><b>BSE Holidays Falling on Weekends (4 holidays)</b></h2>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>BSE Trading Holidays on Weekends</th>
                      <th>Date</th>
                      <th>Day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Republic Day</td>
                      <td>January 26, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Ram Navami</td>
                      <td>April 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                    <tr>
                      <td>Bakra Eid</td>
                      <td>June 7, 2025</td>
                      <td>Saturday</td>
                    </tr>
                    <tr>
                      <td>Muharram</td>
                      <td>July 6, 2025</td>
                      <td>Sunday</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p><b>Market Impact: How BSE holidays impact trading activity, price fluctuations and market trends</b>
              </p>
              <p>
                BSE holidays can have an impact on trading activity, price fluctuations and market trends. When the
                stock market is closed on holidays, no trades are executed, leading to a temporary pause in market
                movement. This may create a backlog of orders that may be processed once the market reopens, potentially
                causing increased volatility and price fluctuations. Market trends are likely to be influenced ahead of
                a holiday, as traders may adjust their positions in anticipation of the market closure. In addition,
                market sentiment could be affected by major events or news that coincide with a trading holiday, which
                impact is likely to be seen in the next trading session. </p>
            </div>
          </div>

        </section>

        <!-- faq Section Start -->
        <section class="calculator_help_section section-padding-bottom faq-sec p-90">
          <div class="container block">
            <h2 class="heading bold help_here text-center">Frequently Asked Questions</h2>
            <div class="smooth-font">
              <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading1">
                    <h3 class="panel-title">
                      <span class="panel-trigger" data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse1">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>When does BSE close in 2025?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">BSE will be closed on following days in 2025 in addition to weekends. Following list does not
                        contain trading holidays that lie on weekends.
                      </p>
                      <ul class="visible">
                        <li><strong>Maha Shivratri</strong>: February 26, 2025 (Wednesday)</li>
                        <li><strong>Holi</strong>: March 14, 2025 (Friday)</li>
                        <li><strong>Eid-ul-Fitr (Ramzan Eid)</strong>: March 31, 2025 (Monday)</li>
                        <li><strong>Mahavir Jayanti</strong>: April 10, 2025 (Thursday)</li>
                        <li><strong>Dr. Baba Saheb Ambedkar Jayanti</strong>: April 14, 2025 (Monday)</li>
                        <li><strong>Good Friday</strong>: April 18, 2025 (Friday)</li>
                        <li><strong>Maharashtra Day</strong>: May 1, 2025 (Thursday)</li>
                        <li><strong>Independence Day</strong>: August 15, 2025 (Friday)</li>
                        <li><strong>Ganesh Chaturthi</strong>: August 27, 2025 (Wednesday)</li>
                        <li><strong>Dussehra (Vijaya Dashami) / Mahatma Gandhi Jayanti</strong>: October 2, 2025
                          (Thursday)</li>
                        <li><strong>Diwali-Laxmi Pujan</strong>: October 21, 2025 (Tuesday)</li>
                        <li><strong>Diwali-Balipratipada</strong>: October 22, 2025 (Wednesday)</li>
                        <li><strong>Guru Nanak Jayanti</strong>: November 5, 2025 (Wednesday)</li>
                        <li><strong>Christmas</strong>: December 25, 2025 (Thursday)</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading2">
                    <h3 class="panel-title">
                      <span class="panel-trigger"  data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse2">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>How do BSE holidays impact the market?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse2" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">BSE holidays pause trading, leading to a temporary halt in market activity. When the market
                        reopens, pent-up orders can cause volatility and price fluctuations. Traders often adjust their
                        positions before holidays, affecting market trends, while news or events during a holiday may
                        impact sentiment, with effects seen after trading resumes.</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading3">
                    <h3 class="panel-title">
                      <span class="panel-trigger"  data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse3">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>Is BSE closed on weekends?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse3" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">Yes, BSE is closed on weekends. The exchange operates Monday through Friday, with trading
                        suspended on Saturdays and Sundays. This means no trades can be placed or executed during the
                        weekend, and any market activity or price changes occur only on weekdays. </p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading4">
                    <h3 class="panel-title">
                      <span class="panel-trigger"  data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse4">
                        <span class="expand_icon dashicons-plus"></span>
                        <span> How to stay updated with BSE holidays in 2025?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse4" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">To stay updated with BSE holidays in 2025, you can regularly check the official BSE website,
                        which publishes the holiday calendar for the year. Apart from that, financial news platforms,
                        trading apps and brokerage websites provide updates and notifications on exchange holidays.</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" id="heading5">
                    <h3 class="panel-title">
                      <span class="panel-trigger"  data-toggle="collapse" data-parent="#calculator_help_section" 
                      href="#collapse5">
                        <span class="expand_icon dashicons-plus"></span>
                        <span>What happens if I place an order on a BSE holiday?</span>
                      </span>
                    </h3>
                  </div>
                  <div id="collapse5" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p class="visible">If you place an order on a BSE holiday, the order will not be executed because the stock
                        exchange is closed for trading.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- End faq Section Start -->
      </div>

      <div class="login-widget smartlist-login">
        <div class="open-account">
          <p class="stock-form-heading"><span>Open a FREE*</span> Demat + Trading account and enjoy</p>
          <p class="form-second-paragraph">Zero commission* on Mutual Funds and IPO</p>
          <p>₹20* per order on Equity, F&amp;O, Commodity and Currency</p>
          <div class="contact-form">
            <form class="contact-input-wrap" method="post" onsubmit="return proceedWithLazyLogin(event, this)">
              <input type="tel" onkeypress="return isNumber(event)" name="phone" id="txtcontact" maxlength="10"
                placeholder="10-Digit mobile number">
              <div class="error-message" id="error-message"></div>
              <button type="submit" class="submit-btn">Start Investing</button>
            </form>
          </div>
          <hr color="#E1E1E1">
          <div class="existing-account">
            By signing up you agree to our <a href="/terms-of-use-and-privacy-policy/">Terms and Conditions</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" src="@/styles/css/stock-market-holiday.scss">
</style>
<style lang="scss" src="@/styles/css/seo-calculators.scss">
</style>
<style scoped>
  .login-widget.smartlist-login .open-account {
    background: #ffffff;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 12px;
    top: 16px;
    width: 100%;
    padding: 24px 24px 16px;
    position: sticky;
  }

  .login-widget.smartlist-login .open-account .header {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.03em;
    color: #5a298b;
  }

  .login-widget.smartlist-login .open-account p {
    font-size: 12px;
    line-height: 16px;
    color: #6a6a6a;
    padding-top: 8px;
  }

  .login-widget.smartlist-login .open-account .contact-form h6 {
    color: #262626;
    font-size: 14px;
    line-height: 20px;
    padding-top: 16px;
    padding-bottom: 8px;
  }

  .smartlist-login .contact-form input {
    width: 100%;
    border-radius: 8px;
    background: #f2f2f2;
    line-height: 24px;
    padding: 8px 8px 8px 36px;
    font-size: 14px !important;
    border: 1px solid transparent;
  }

  .smartlist-login input:focus-visible {
    border-color: #7a26ce !important;
    outline: none;
  }

  .smartlist-login input::-webkit-input-placeholder {
    /* Edge */
    color: #aeaeae;
  }

  .smartlist-login input:-ms-input-placeholder {
    /* Internet Explorer */
    color: #aeaeae;
  }

  .smartlist-login input::placeholder {
    color: #aeaeae;
  }

  .smartlist-login .contact-input-wrap {
    position: relative;
  }

  .smartlist-login .contact-input-wrap::after {
    content: "+91";
    position: absolute;
    color: #6a6a6a;
    top: 9px;
    font-size: 14px;
    line-height: 24px;
    left: 8px;
    font-family: Messina Sans;
  }

  .smartlist-login .error-message span {
    margin-top: 8px;
    display: inline-block;
    font-size: 12px;
    color: #db542a;
  }

  .smartlist-login .error-message span:empty {
    display: none;
  }

  .smartlist-login .submit-btn {
    width: 100%;
    height: 48px;
    background: #5a298b !important;
    border: 1px solid transparent !important;
    border-radius: 24px !important;
    padding: 10px 25px !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 24px !important;
    margin-top: 16px !important;
    transition: all 0.3s ease-in-out 0.1s;
    cursor: pointer;
  }

  .smartlist-login .open-account hr {
    margin: 24px -24px 16px -24px;
    border-color: #e1e1e1;
  }

  .smartlist-login .existing-account {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .smartlist-login .existing-account p {
    padding: 0px !important;
    font-size: 12px;
    line-height: 16px;
    font-family: Messina Sans;
    color: #262626;
  }

  .smartlist-login .login-btn {
    border: 1px solid #d0d0d0 !important;
    border-radius: 100px;
    padding: 8px 16px !important;
    background: white;
    cursor: pointer;
    height: auto !important;
  }

  .smartlist-login .login-btn span {
    font-family: Messina Sans;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: #262626;
  }

  .smartlist-login .login-btn:hover span {
    color: #5a298b;
  }

  .smartlist-login .contact-input-wrap:after {
    top: 9px !important;
  }

  @media screen and (max-width: 768px) {
    .login-widget .open-account {
      width: 100%;
      margin-top: 32px;
      position: static;
    }

    .smartlist-login .open-account hr {
      display: none;
    }

    .smartlist-login .existing-account {
      display: none;
    }
  }
</style>